import { IContentTileActionObj } from 'ui-ng-content-tile';
import { IScheduleSection } from '../../types/my_schedule_types';

interface IScheduleCourseModel {
  course: IScheduleSection;
  courseAction: IContentTileActionObj;
}
export class MyScheduleCourseController {
  private models: IScheduleCourseModel;
  private course: IScheduleSection;
  private sectionLabel: string = 'Section';
  private VIEWABLE_THRESHOLD: number = 8;
  private showMoreSectionLabels: boolean;

  constructor(private $state: ng.ui.IStateService, private appConfigModel: any) {}

  $onInit() {
    this.sectionLabel = this.appConfigModel.getConfigProperty('section_label') || 'Section';
    this.models = {
      course: this.course,
      courseAction: {
        state: 'my.courseSchedule.detail',
        params: {
          id: this.course.id
        }
      }
    };
    this.showMoreSectionLabels = this.models.course._sectionLabels.section_label.length > this.VIEWABLE_THRESHOLD;
  }
}

export class ScheduleCourseComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-course-schedule/src/components/my_schedule_course/my_schedule_course.html';
  public controller: any = MyScheduleCourseController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    course: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/components/my_schedule_course/my_schedule_course_controller.ts